<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('email.EmailListing.deleteConfirmModal.title')"
        :closeOnClickOverlay="false"
        class="email-listing-delete-confirm-dialog"
        :primaryAction="{
            label: $t.__('common.actions.confirm'),
            loading: isLoading,
            type: 'primary-destructive',
            action: () => handleConfirm(),
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                action: () => {
                    $emit('close');
                },
            },
        ]"
        @closed="closeModal"
    >
        <template slot="default">
            <p
                class="typographies-paragraph-medium-regular email-listing-delete-confirm-dialog__description"
                v-html="
                    $t.__('email.EmailListing.deleteConfirmModal.description', {
                        emailSubject: email.subject,
                    })
                "
            />
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        email: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            isLoading: false,
        };
    },
    mounted() {
        this.showModal = true;
    },
    methods: {
        handleConfirm() {
            this.isLoading = true;
            this.$trigger('delete:email', this.email);
            setTimeout(() => {
                this.isLoading = false;
                this.closeModal();
            }, 1000);
        },
        closeModal() {
            this.showModal = false;
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss" scoped>
.email-listing-delete-confirm-dialog {
    &__description {
        margin: 0;
    }
}
</style>
